export const SUBMISSION_KIT_TAGS_HEADSHOT = 'headshot';
export const SUBMISSION_KIT_TAGS = {
  headshot: 'HEADSHOT',
  fullbody: 'FULL BODY',
  currentlook: 'Current Look',
  photo1: 'PHOTO 1',
  photo2: 'PHOTO 2',
  reel1: 'REEL 1',
  reel2: 'REEL 2',
  selftape1: 'AUDITION 1',
};
